module.exports = __webpack_public_path__ + "img/commission-warehouse.f522dfab.svg";